<template>
  <div class="ValidateAddress">
    <v-container fluid fill-height>
      <v-layout
        justify-center
        align-center
      >
        <v-flex md8>
          <v-card class="mb-2">
            <v-card-title class="title">
              Validar Direcciones
              <v-spacer/>

              <v-text-field
                v-if="!loading && dataVals.length !== 0"
                v-model="search"
                append-icon="search"
                label="Buscar"
                single-line
                hide-details
              ></v-text-field>
            </v-card-title>

            <v-card-text
              v-if="loading"
              class="text-xs-center"
            >
              <v-progress-circular
                :size="progressSize"
                :width="progressWidth"
                :value="completed"
                color="info"
              >
                {{ progressAdvance }}
                {{ progressTotal }}
              </v-progress-circular>
            </v-card-text>

            <v-card-text v-else>
              <v-data-table
                dense
                :headers="headers"
                :items="dataVals"
                :search="search"
                no-results-text="No se encontro el término buscado"
                no-data-text="No hay datos disponibles"
                multi-sort
                disable-initial-sort
                class="elevation-1"
                loading="Cargando... Por favor espere."
                :key="tableKey"
              >
                <template v-slot:items="props">
                  <td> {{ props.item.dir_viv }} </td>
                  <td>
                    <v-layout align-center justify-space-around>
                      <v-btn
                        flat
                        icon
                        :href="props.item.url"
                        target="_blank"
                        color="info"
                        >
                        <v-icon>room</v-icon>
                      </v-btn>
                    </v-layout>
                  </td>
                  <td>
                    <v-layout align-center justify-space-around>
                      <v-icon
                        color="success"
                        @click="editPoll(props.item, 'V')"
                      >
                        where_to_vote
                      </v-icon>
                      <v-icon
                        color="error"
                        @click="editPoll(props.item, 'I')"
                      >
                        cancel
                      </v-icon>
                      <v-icon
                        color="warning"
                        @click="editPoll(props.item, 'NV')"
                      >
                        warning
                      </v-icon>
                    </v-layout>
                  </td>
                </template>
              </v-data-table>
            </v-card-text>

            <v-dialog v-model="dialog" max-width="500px">
              <v-card>
                <v-card-title>
                  <span class="headline">Validar Dirección</span>
                </v-card-title>
                <v-card-text v-if="incidenceType === 'I'">
                  Motivo para descartar la dirección: <br>
                  <v-autocomplete
                    v-model="incidence"
                    :items="tipesOfIncidence"
                    label="Tipo de incidencia"
                  ></v-autocomplete>
                </v-card-text>

                <v-card-text>
                  Esta acción no se puede deshacer
                  <v-checkbox
                    v-model="checkbox"
                    label="Confirmo que deseo validar la dirección"
                  ></v-checkbox>
                </v-card-text>

                <v-alert :value="alert" type="error">
                  No se ha podido realizar la validación
                </v-alert>

                <v-card-actions>
                  <v-spacer/>
                  <v-btn color="info" @click="close">Cancelar</v-btn>
                  <v-btn
                    :disabled="validate"
                    color="warning"
                    @click="save"
                  >Enviar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>

export default {
  name: `ValidateAddress`,
  // TODO: adjuntar archivo evidencia de validación
  // https://serversideup.net/uploading-files-vuejs-axios/

  /**
   * Esta función carga el respectivo Layout, al crear la vista.
   */
  created () {
    this.$store.commit('SET_LAYOUT', 'dashboard-layout')
    this.getPolls()
  },

  data: function () {
    return {
      backConf: {
        path: '/ccb/verificacion',
        page: 1
      },

      search: '',
      dialog: false,
      loading: false,
      progressSize: 70,
      progressWidth: 7,
      progressTotal: 0,
      progressAdvance: 0,
      completed: 0,

      alert: false,

      headers: [
        // {
        //   text: 'Identificador',
        //   align: 'left',
        //   value: 'id'
        // },
        { text: 'Dirección', value: 'dir_viv', align: 'left' },
        { text: 'Link de verificación', value: 'url', align: 'center' },
        { text: 'Acciones', value: '', align: 'center', sortable: false }
      ],
      dataVals: [],
      tableKey: 0,

      editedIndex: -1,
      editedPoll: {},
      checkbox: false,
      tipesOfIncidence: [
        { value: 6, text: 'La dirección no corresponde o no existe' },
        { value: 7, text: 'Vivienda vacía' },
        { value: 9, text: 'Otros usos' }
      ],
      incidenceType: null,
      incidence: null
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    },

    'dataVals': function () {
      this.completed = (this.progressAdvance / this.progressTotal) * 100
    }
  },

  computed: {
    /** Valida si se debe o no enviar el envio
     */
    validate: function validate () {
      return !this.checkbox || (this.incidenceType === 'I' && this.incidence === null)
    }
  },

  methods: {
    /** Carga la información de las encuestas
     */
    getPolls () {
      this.loading = true
      let request = {
        method: 'get',
        data: {},
        url: this.backConf.path + '?page=' + this.backConf.page
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.progressTotal = resp.data.count
          t.progressAdvance = t.dataVals.length

          t.dataVals = t.dataVals.concat(resp.data.results)
          if (resp.data.next !== null) {
            t.backConf.page += 1
            t.getPolls()
          } else {
            t.backConf.page = 1
            t.loading = false
          }
        })
        .catch(err => console.error(err))

      t.tableKey += 1
    },

    /** Selecciona al encuesta a validar
     * @param  {object} poll encuesta a validar
     * @param  {char} inc  tipo de incidencia
     */
    editPoll (poll, inc) {
      this.editedIndex = this.dataVals.indexOf(poll)
      this.incidenceType = inc
      this.editedPoll = Object.assign({}, poll)
      this.dialog = true
    },

    /** Limpia el formulario de validación y limpia los elementos asociados
     */
    close () {
      this.dialog = false
      this.incidenceType = null
      this.incidence = null
      this.checkbox = false
      setTimeout(() => {
        this.editedPoll = {}
        this.editedIndex = -1
      }, 300)
    },

    /** envia la validación,
     * actualiza la tabla local
     */
    save () {
      let request = {
        method: 'patch',
        data: {
          id: this.editedPoll.id,
          est: this.incidenceType,
          incidencia: this.incidence
        },
        url: this.backConf.path
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.dataVals.splice(t.editedIndex, 1)
          t.alert = false
          t.close()
        })
        .catch(function (err) {
          t.alert = true
          console.error(err)
        })
    }
  }
}
</script>
